/**
 * URL canónica del sitio para SEO (canonical, OG, sitemap).
 * Prioridad: VITE_SITE_URL → altenot.com → origen actual en runtime.
 */

const DEFAULT_SITE = "https://altenot.com";

export function getSiteOrigin(): string {
  const fromEnv = import.meta.env.VITE_SITE_URL as string | undefined;
  if (fromEnv?.trim()) {
    return fromEnv.replace(/\/+$/, "");
  }
  if (typeof window !== "undefined" && window.location?.origin) {
    const { origin } = window.location;
    if (origin.startsWith("http://localhost")) {
      return DEFAULT_SITE;
    }
    return origin;
  }
  return DEFAULT_SITE;
}

export function absoluteUrl(path: string): string {
  const normalized = path.startsWith("/") ? path : `/${path}`;
  return `${getSiteOrigin()}${normalized}`;
}
